// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_TemplateCreateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_TemplateCreateInput — body for
 * POST /franchisor-channels/template-create.
 *
 * The ONLY create path templates have, and it creates exactly one thing: the
 * language variant of a pair that is already seeded. It copies the pt-BR
 * subject/body so staff translates over real text instead of starting from a
 * blank editor.
 *
 * Refusals: 'trigger_unknown', 'language_unsupported',
 * 'template_variant_exists', 'template_not_found' (no pt-BR source to copy).
 */
import { registerContract } from './validate'

export interface FranchisorChannels_TemplateCreateInput {
trigger_key: string
channel_type: string
language: string
}

registerContract('FranchisorChannels_TemplateCreateInput', {
  trigger_key:  { type: 'string',  required: true },
  channel_type: { type: 'string',  required: true },
  language:     { type: 'string',  required: true },
})
